import React, { useRef, useEffect, useState, useCallback } from 'react'
import { useInView } from 'react-intersection-observer'
import { useGetResizer } from '@/contexts/Resizer'
import { useGetTheme } from '@/contexts/ThemingContext'
import { easing } from '@/util/math'

import {
  useViewportScroll,
  motion,
  useTransform,
  useSpring,
  useMotionValue,
  AnimatePresence,
  animate,
} from 'framer-motion'

import Image from './Image'

import styled from '@emotion/styled'
// import { h2 } from '@/styles/typography'
import { spacing, screen, grid, ratio, fontSize } from '@/styles/mixins'

const Panel = styled.div`
  position: relative;
  min-height: 120vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 2;
  .inner {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .text {
    color: white;
    transition: opacity 0.2s ease-in-out;
    z-index: 2;
    position: relative;
    max-width: 540px;

    p {
      font-size: 1.3rem;
      @media (orientation: portrait) {
        font-size: 1.1rem;
      }
    }
  }
  .cuerpo {
    position: relative;
  }

  .media {
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.4s ease-in-out;
    position: fixed;
    will-change: opacity;
  }

  &.active {
    .media {
      opacity: 1;
    }
  }
  &.active-0 {
    position: sticky;
  }
`

const Title = styled.h2`
  font-size: 3rem;
  ${spacing('marginBottom', 'm')};
  text-shadow: rgb(0 0 0 / 90%) 0px 0px 2px, rgb(0 0 0 / 60%) 0px 0px 20px;
`

const Body = styled.div`
  position: relative;
  text-shadow: rgb(0 0 0 / 90%) 0px 0px 2px, rgb(0 0 0 / 60%) 0px 0px 20px;
  pointer-events: none;

  a {
    text-decoration: underline;
    position: relative;
    pointer-events: auto;
  }
`
const BodyCopy = styled.div`
  position: absolute;
  top: 0;
  z-index: -1;
  text-shadow: rgb(0 0 0 / 90%) 0px 0px 2px, rgb(0 0 0 / 60%) 0px 0px 20px;
  a {
    text-decoration: underline;
  }
  span {
    display: inline;
    background-color: #222222;
    box-shadow: 15px 7px 0 #222222, -15px -5px 0 #222222, 15px -5px 0 #222222,
      -15px 7px 0 #222222;
    opacity: 0.4;
    color: transparent;
  }
`

const Media = styled.div`
  z-index: 1;
  width: 100vw;
  height: 100vh;
  left: 0;
  right: 0;
  max-width: none !important;
  top: 0;
`

const PanelComponent = ({ panel, index, totalLength, active, onActive }) => {
  const { titulo, cuerpo, fondo } = panel
  const fondoMobile = panel['fondo-mobile']

  const paragraphs = cuerpo
    ? cuerpo.replace(/<p>/g, '<p><span>').replace(/<\/p>/g, '</span></p>')
    : null

  const [prev, setPrev] = useState(null)
  const [next, setNext] = useState(null)
  const [toLoad, setToLoad] = useState(false)

  const [windowHeight, setWindowHeight] = useState(768)
  const [isVisible, setIsVisible] = useState(false)
  const [refTop, setRefTop] = useState(0)
  const [refBottom, setRefBottom] = useState(1)

  useEffect(() => {
    if (active > 1 && active - 1 === index) {
      setPrev(active - 1)
    } else {
      setPrev(null)
    }
    if (active < totalLength && active + 1 === index) {
      setNext(active + 1)
    } else {
      setNext(null)
    }
    if (
      active === index ||
      (active > 1 && active - 1 === index) ||
      (active < totalLength && active + 1 === index)
    ) {
      setToLoad(true)
    } else {
      setToLoad(false)
    }
  }, [active, prev, next])

  const { ref, inView, entry } = useInView({
    threshold: 0.7,
  })

  useEffect(() => {
    if (inView) {
      setIsVisible(true)
      onActive(index)
      try {
        window.location.replace(`#panel-${index + 1}`)
      } catch (e) {
        console.log(e)
      }
    } else {
      setIsVisible(false)
      // onActive(index)
    }
  }, [inView])
  const localindex = index + 1
  return (
    <Panel
      ref={ref}
      id={`panel-${localindex}`}
      className={`${
        active === index ? `active active-${localindex}` : 'inactive'
      }${prev ? ' prev' : ''}${next ? ' next' : ''}`}>
      <div className="inner">
        <div className="text">
          {titulo && <Title dangerouslySetInnerHTML={{ __html: titulo }} />}
          {cuerpo && (
            <div className="cuerpo">
              <Body dangerouslySetInnerHTML={{ __html: paragraphs }} />
              <BodyCopy dangerouslySetInnerHTML={{ __html: paragraphs }} />
            </div>
          )}
        </div>
        {fondo && (
          <>
            <Media className="media">
              {toLoad && <Image img={fondo} mobileimg={fondoMobile} />}
            </Media>
          </>
        )}
      </div>
    </Panel>
  )
}

export default PanelComponent
